import React from 'react';

/**
 * Displays the ipr title
 * @component
 */
export default function IPRTitle(props) {
  return <div className="ipr-title">IPR Table</div>;
}
